/** Canonical pipeline order — keep in sync with backend `projectController` STAGES. */
export const PROJECT_PIPELINE_STAGES = [
  'Not started',
  'Team Assignment',
  'Material Requested',
  'Pending Store',
  'Owner Approval',
  'Dispatched',
  'Project started',
  'Carpenter Complete',
  'Electrician Complete',
  'Painter Complete',
  'Plumber Complete',
  'Documents',
  'Bill Approval',
  'Completed'
];

/** Legacy DB value before Civil / Electrical / Mechanical split. */
export const LEGACY_INSTALLATION_COMPLETED = 'Installation completed';

/** Work Update Options */
export const UPDATE_OPTIONS = [
  { value: 'STARTED', label: 'Started' },
  { value: 'IN_PROGRESS', label: 'In progress' },
  { value: 'ON_HOLD', label: 'On hold' },
  { value: 'WAITING_MATERIAL', label: 'Waiting for material' },
  { value: 'COMPLETED', label: 'Completed' }
];

/** Character and Numeric Limits */
export const WORK_UPDATE_LIMITS = {
  TITLE_MIN: 3,
  TITLE_MAX: 120,
  DESC_MAX: 2000
};

export const TASK_LIMITS = {
  NAME_MIN: 3,
  NAME_MAX: 120,
  DESC_MAX: 2000
};
